var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailRejection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13059 -3974)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4254.828 2073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,1A1,1,0,0,0,1,2V9a1,1,0,0,0,1,1H12a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H12a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H2A2,2,0,0,1,0,9V2A2,2,0,0,1,2,0Z",
    transform: "translate(17313.828 1901)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17317.305 1903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.676,1A2.6,2.6,0,0,0,1,3.5,2.6,2.6,0,0,0,3.676,6,2.6,2.6,0,0,0,6.353,3.5,2.6,2.6,0,0,0,3.676,1m0-1A3.591,3.591,0,0,1,7.353,3.5,3.591,3.591,0,0,1,3.676,7,3.591,3.591,0,0,1,0,3.5,3.591,3.591,0,0,1,3.676,0Z",
    transform: "translate(-0.037)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.568.513h0L0,.5A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5L2.57-.487a.5.5,0,0,1,0,1Z",
    transform: "translate(2.74 2.589) rotate(45)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,.513a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5L2.57-.5a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5L0,.513Z",
    transform: "translate(4.555 2.595) rotate(135)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17318.494,1904.943l-4.129-2.55.527-.851,4.129,2.55Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17323.582,1905.063l-.57-.823,3.652-2.525.57.823Z",
    fill: "#707070"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRejection);
export default __webpack_public_path__ + "static/media/email_rejection.c86b60bc8a1e740c806c70936a5546f5.svg";
export { ForwardRef as ReactComponent };